import { Order, Product } from "../../types/interfaces";
import { stepLabels } from "../workflows.utils";
import {
  InformationMappedValues,
  updateInformation,
} from "./savePartialDentureInfo.utils";
import {
  ProsthesisMappedValues,
  updateProsthesis,
} from "./savePartialDentureProthesis.utils";
import {
  HooksAndOptionsMappedValues,
  updateHooksAndOptions,
} from "./savePartialDentureHooksAndOptions.utils";
import {
  FlowMappedValues,
  updateFlow,
} from "./savePartialDentureWorkflow.utils";

export const savePartialDenture = async (
  updateOrder: (data: {
    variables: {
      data: any;
      where: { id: string };
    };
  }) => Promise<Order>,
  mappedValues:
    | InformationMappedValues
    | ProsthesisMappedValues
    | HooksAndOptionsMappedValues
    | FlowMappedValues,
  orderId: string,
  currentStepLabel: string,
  product: Product
) => {
  try {
    switch (currentStepLabel) {
      case stepLabels.PARTIAL_DENTURE.INFORMATION:
        return await updateInformation(
          updateOrder,
          mappedValues as InformationMappedValues,
          orderId,
          product
        );
      case stepLabels.PARTIAL_DENTURE.PROTHESIS:
        return await updateProsthesis(
          updateOrder,
          mappedValues as ProsthesisMappedValues,
          orderId,
          product
        );
      case stepLabels.PARTIAL_DENTURE.HOOKS_AND_OPTIONS:
        return await updateHooksAndOptions(
          updateOrder,
          mappedValues as HooksAndOptionsMappedValues,
          orderId,
          product
        );
      case stepLabels.PARTIAL_DENTURE.FLOW:
        return await updateFlow(
          updateOrder,
          mappedValues as FlowMappedValues,
          orderId,
          product
        );
      // New PAP workflow steps - these are handled by refs, so we just return true here
      case stepLabels.PARTIAL_DENTURE.ORDER_TYPE:
      case stepLabels.PARTIAL_DENTURE.MATERIAL:
      case stepLabels.PARTIAL_DENTURE.AESTHETICS:
        return true;
      default:
        console.warn(
          `Step "${currentStepLabel}" not handled for partial denture save.`
        );
        return true;
    }
  } catch (error) {
    console.error("Failed to save partial denture:", error);
    throw error;
  }
};
